<template>
  <div class="container">
    <div class="row justify-content-md-center">
      <div class="col-lg-6 col-md-8 col-sm-12">
        <h1>Sign Up</h1>
        <b-card bg-variant="light" class="mt-1">
          <b-card-body class="special">
            <b-form @submit.prevent="onRegister" novalidate>
              <b-form-group class="mb-0">
                <b-form-group
                  id="firstname-input-group"
                  label="First Name"
                  label-for="firstname-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="firstname-input"
                    type="text"
                    name="firstName"
                    placeholder="First name (at least 1 character)"
                    v-model.trim="item.firstName"
                    v-validate="'required'"
                    data-vv-as="First Name"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('firstName') }"
                    :disabled="isLoading"
                    aria-describedby="firstname-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="firstname-input-live-feedback">
                    {{ getError("firstName") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="lastname-input-group"
                  label="Last Name"
                  label-for="lastname-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="lastname-input"
                    type="text"
                    name="lastName"
                    placeholder="Last name (at least 2 characters)"
                    v-model.trim="item.lastName"
                    v-validate="'required|min:2'"
                    data-vv-as="Last Name"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('lastName') }"
                    :disabled="isLoading"
                    aria-describedby="lastname-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="lastname-input-live-feedback">
                    {{ getError("lastName") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="email-input-group"
                  label="Email"
                  label-for="email-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="email-input"
                    type="email"
                    name="email"
                    placeholder="Please enter a valid email address"
                    v-model.trim="item.email"
                    v-validate="'required|email'"
                    data-vv-as="Email"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('email') }"
                    :disabled="isLoading"
                    aria-describedby="email-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="email-input-live-feedback">
                    {{ getError("email") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="username-input-group"
                  label="Username"
                  label-for="username-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="username-input"
                    type="text"
                    name="username"
                    placeholder="Username (at least 2 characters)"
                    v-model.trim="item.username"
                    v-validate="'required|min:2'"
                    data-vv-as="Userame"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('username') }"
                    :disabled="isLoading"
                    aria-describedby="username-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="username-input-live-feedback">
                    {{ getError("username") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="password-input-group"
                  label="Password"
                  label-for="password-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="password-input"
                    type="password"
                    name="password"
                    placeholder="Password (at least 12 characters)"
                    v-model.trim="item.password"
                    v-validate="'required|min:12'"
                    data-vv-as="Password"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('password') }"
                    :disabled="isLoading"
                    ref="password"
                    aria-describedby="passowrd-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="password-input-live-feedback">
                    {{ getError("password") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="confirm-password-input-group"
                  label="Confirm Password"
                  label-for="confirm-password-input"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-input
                    id="confirm-password-input"
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm password (must match)"
                    v-model.trim="item.confirmPassword"
                    v-validate="'required|confirmed:password'"
                    data-vv-as="Confirm Password"
                    data-vv-delay="500"
                    :class="{ 'is-invalid': isInvalid('confirmPassword') }"
                    :disabled="isLoading"
                    aria-describedby="confirm-password-input-live-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    id="confirm-password-input-live-feedback"
                  >
                    {{ getError("confirmPassword") }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                  id="receive-newsletter-input-group"
                  label="Receive Newsletter"
                  label-for="newsletter"
                  label-class="font-weight-bold"
                  label-cols-sm="5"
                  label-cols-lg="4"
                >
                  <b-form-checkbox
                    name="newsletter"
                    v-model="item.receivesNewsletter"
                    :value=true
                    :unchecked-value=false
                    switch
                    size="lg">
                  </b-form-checkbox>
                </b-form-group>

                <p class="message-holder" v-show="error">{{ error }}</p>

                <b-form-group id="sign-up-input-group">
                  <b-checkbox class="justify-center" v-model="privacyChk">
                    Agree to our <b-link class="bold" @click="privacyChk = !privacyChk"><b>Terms of Use and Privacy Policy</b></b-link> <br/>
                    <span class="message-holder" v-show="isPrivacyEmpty">
                      You must agree to our Terms of Use and Privacy Policy to Sign Up
                    </span>
                  </b-checkbox>
                  <div class="mt-4 mb-1 text-muted small">
                    The reCAPTCHA service may collect device, browser, network, and interaction signals for security and automated bot/spam prevention purposes.
                    See our Terms of Use and Privacy Policy for further details.
                  </div>
                  <b-form-group id="recaptcha-input-group"
                                label-cols-md="2"
                                label-cols-lg="3">
                    <GoogleRecaptcha
                      ref="recaptcha"
                      action="signup"
                      :show-error="isRecaptchaEmpty"
                      @verified="recaptchaVerified"
                      @expired="recaptchaExpired"
                    >
                      <template #error>
                        Please prove you are not a bot to Sign Up
                      </template>
                    </GoogleRecaptcha>
                  </b-form-group>
                  <b-button type="submit" block class="JoinCitSci" variant="primary">
                    <font-awesome-icon icon="spinner" pulse v-show="isLoading"/>
                    Sign Up
                  </b-button>
                </b-form-group>
              </b-form-group>
            </b-form>
          </b-card-body>
        </b-card>
      </div>
    </div>

    <b-modal
      id="privacy-terms"
      ref="privacyTerms"
      title="Review our Terms of Use and Privacy Policy"
      size="xl"
      no-fade
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      no-stacking
      centered
    >
      <TermsPrivacy></TermsPrivacy>
      <template slot="modal-footer">
        <b-btn variant="secondary" class="mr-auto" @click="() => {onPrivacyModalClose(false);}">
          Decline
        </b-btn
        >
        <b-btn variant="primary" class="float-right" @click="() => { onPrivacyModalClose(true); }">
          Accept
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GoogleRecaptcha from "./GoogleRecaptcha.vue";
import TermsPrivacy from "../terms_privacy/Terms_Privacy.vue";

export default {
  components: {
    TermsPrivacy,
    GoogleRecaptcha,
  },

  data() {
    return {
      item: {
        privacySetting: 2,
        receivesNewsletter: true,
        recaptchaToken: "",
        isAgreedPrivacy: false,
      },
      privacyChk: false,
      privacyEmpty: false,
      recaptchaEmpty: false,
    };
  },

  computed: {
    ...mapGetters({
      error: "user/register/error",
      isLoading: "user/register/isLoading",
      created: "user/register/created",
      violations: "user/register/violations",
      isAuthenticated: "user/auth/isAuthenticated",
      hasSession: "user/profile/hasSession",
      isLoadingSession: "user/profile/isLoadingSession",
    }),

    isPrivacyEmpty: {
      get() {
        return this.privacyEmpty
      },
      set(newVal) {
        this.privacyEmpty = newVal
      },
    },

    isRecaptchaEmpty: {
      get() {
        return this.recaptchaEmpty
      },
      set(newVal) {
        this.recaptchaEmpty = newVal
      },
    },
  },

  watch: {
    hasSession: function (hasSession) {
      if (this.isAuthenticated === false || hasSession === false) {
        return;
      }
      let redirectPath =
        (this.$route.query && this.$route.query.redirect) || "";
      if (redirectPath.length > 0) {
        this.$router.push({path: redirectPath});
        return;
      }
      this.$router.push({name: "ProfileShow"});
    },
    privacyChk(newVal) {
      if (newVal) {
        //Show popup
        this.privacyEmpty = false;
        this.$bvModal.show("privacy-terms");
        this.item.isAgreedPrivacy = true;
      } else {
        this.privacyEmpty = true;
        this.item.isAgreedPrivacy = false;
      }
    },
  },

  created() {
    this.reset();
    this.$validator.validateAll();

    // Handle invites for new user
    let redirectPath = this.$route.query.redirect || "";
    // JWT is extracted
    let token = redirectPath.substring(redirectPath.lastIndexOf("/") + 1) || "";

    // If JWT present
    if (token.length > 0) {
      let decodedToken = null;
      try {
        decodedToken = this.$jwt.decode(token);
      } catch (e) {
        return;
      }

      // Expired JWT
      if (decodedToken.exp * 1000 < new Date().getTime()) {
        return;
      }

      // User's name and email are populated from JWT
      this.item.email = (decodedToken && decodedToken.code) || "";
      this.item.firstName = (decodedToken && decodedToken.data.firstName) || "";
      this.item.lastName = (decodedToken && decodedToken.data.lastName) || "";
    }
  },

  methods: {
    ...mapActions({
      register: "user/register/register",
      authenticate: "user/auth/authenticate",
      retrieveUser: "user/profile/fetchSession",
      reset: "user/register/reset",
    }),

    recaptchaVerified(response) {
      this.item.recaptchaToken = response
      this.isRecaptchaEmpty = false
    },

    recaptchaExpired() {
      console.log('recaptcha expired')
      this.item.recaptchaToken = ""
      this.isRecaptchaEmpty = true
    },

    onRegister() {
      this.$validator.validateAll().then((result) => {
        this.isRecaptchaEmpty = this.item.recaptchaToken === "";
        this.isPrivacyEmpty = !this.item.isAgreedPrivacy;
        if (result && !this.recaptchaEmpty && !this.isPrivacyEmpty) {
          this.register(this.item).then((creds) => {
            this.resetRecaptcha();
            if (creds) {
              if (this.$route.query.redirect) {
                // accept invite / other redirects if present
                this.$router.push({path: this.$route.query.redirect});
              } else {
                // Redirect to signup success + email verify page
                this.$router.replace({name: "VerifyEmail"});
              }
            }
          })
            .catch((error) => {
              this.resetRecaptcha();
            });
        } else {
          this.resetRecaptcha();
        }
      });
    },

    resetRecaptcha() {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
      this.item.recaptchaToken = "";
    },

    isInvalid(key) {
      return ((this.violations !== null && Object.keys(this.violations).length > 0 && this.violations[key]) || this.errors.has(key));
    },

    getError(key) {
      if (this.errors.has(key)) {
        return this.errors.first(key);
      }

      if (this.violations && Object.keys(this.violations).length > 0 && this.violations[key]) {
        return this.violations.key;
      }
    },

    onPrivacyModalClose(bAccept) {
      if (!bAccept) {
        this.item.isAgreedPrivacy = bAccept;
        if (this.privacyChk) {
          // Show validation error
          this.isPrivacyEmpty = true;
        } else {
          this.isPrivacyEmpty = false;
        }
        this.privacyChk = bAccept;
      }
      this.$refs.privacyTerms.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.JoinCitSci {
  width: 160px;
  margin-left: auto;
  margin-right: auto;
  font-weight: bold;
}

.card-body {
  background-color: #f5f4e8 !important;
}
</style>
